import React from 'react'

import './FocusMattersSlide.scss'

export const FocusMattersSlide = (): React.ReactElement => {
  return (
    <div className="slide-container">
      <div className="consumerImage-3" />
      <h1 className="header-consumer-3 mt-4 mb-2">Focus on what matters to you</h1>
      <p className="subheader-consumer-3">
        Customise your view to surface exactly what you need to know with sophisticated filters.
      </p>
      <p className="text-sm text-inactive productConsumer">gfknewron Consumer</p>
    </div>
  )
}
